import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { ListRange } from '../../../../../common/models/list.model';
import { MeasurementUnitCodesEnum } from '../../../../../common/models/unit-system.model';
import { LoadAllFacade, SetInitialStateFacade } from '../../../../../common';
import { Observable } from 'rxjs';
import { take } from 'rxjs/operators';
import {
  ShipmentTransportOrderMaterialsState,
  ShipmentTransportOrderMaterialsStateModel,
} from './shipment-transport-order-materials.state';
import {
  ShipmentTransportOrderMaterialsInitialState,
  ShipmentTransportOrderMaterialsLoad,
} from './shipment-transport-order-materials.actions';
import { ShipmentTransportOrderMaterialModel } from '../../models/shipment-transport-order-materials.model';
import { ShipmentTransportOrderItemFacade } from '../shipment-transport-order-item.facade';
import { TransportOrderIdView } from '../../../../models';

@Injectable({
  providedIn: 'root',
})
export class ShipmentTransportOrderMaterialsFacade implements LoadAllFacade, SetInitialStateFacade {
  listDto$: Observable<ShipmentTransportOrderMaterialsStateModel> = this.store.select(
    ShipmentTransportOrderMaterialsState.getState,
  );
  items$: Observable<ShipmentTransportOrderMaterialModel[]> = this.store.select(
    ShipmentTransportOrderMaterialsState.getMaterials,
  );
  dimensionsUnitCode$: Observable<MeasurementUnitCodesEnum> = this.store.select(
    ShipmentTransportOrderMaterialsState.getDimensionsUnitCode,
  );
  weightUnitCode$: Observable<MeasurementUnitCodesEnum> = this.store.select(
    ShipmentTransportOrderMaterialsState.getWeightUnitCode,
  );
  volumeUnitCode$: Observable<MeasurementUnitCodesEnum> = this.store.select(
    ShipmentTransportOrderMaterialsState.getVolumeUnitCode,
  );
  loaded$: Observable<boolean> = this.store.select(ShipmentTransportOrderMaterialsState.getLoaded);

  constructor(private store: Store, private shipmentTransportOrderItemFacade: ShipmentTransportOrderItemFacade) {}

  loadAll(listRange?: ListRange): void {
    this.shipmentTransportOrderItemFacade.shipmentTransportOrderIdentifier$
      .pipe(take(1))
      .subscribe((transportOrderIdView: TransportOrderIdView) => {
        this.store.dispatch(new ShipmentTransportOrderMaterialsLoad({ ...listRange, transportOrderIdView }));
      });
  }

  setInitialState(): void {
    this.store.dispatch(new ShipmentTransportOrderMaterialsInitialState());
  }
}
